// @flow
import React from 'react'

type Props = {
  title: string
}

export default class PDTitle extends React.Component<Props> {
  render () {
    return (
      <div style={{display: 'flex', alignItems: 'center'}}>
        <a href={`http://${this.props.title}`} target='_blank' >
          <span className='header-description__namespace-name m-width-522 mt-negative-2 line-height-29'
            style={{color: 'black', textOverflow: 'ellipsis'}}>
            {this.props.title}
          </span>
        </a>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./app/javascript/packs/components/project_dashboard/Header/DashboardTitle.js